import { useQuery } from 'react-query';

import { axios } from 'configurations/axios';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { useSessionStore } from 'session/useSessionStore';
import { IGroupLayer } from '../models/interfaces/IGroupLayer';

export const useGetGroupLayers = (
    dataSourceId: number | undefined,
    parentGroupId: number | undefined,
    enabled: boolean,
) => {
    const { host, jwt } = useSessionStore(state => ({
        host: state.tenantConfiguration?.endpoints.webApiHost,
        jwt: state.jwtToken,
    }));

    return useQuery<IGroupLayer[]>(
        ['GetGroupLayers', dataSourceId, parentGroupId ?? null],
        async () => {
            const response = await axios.get<IResponseAPI<IGroupLayer[]>>(
                `${host}/Map/GroupLayer/GetAll`,
                {
                    params: {
                        dataSourceId,
                        ...(parentGroupId !== undefined ? { parentGroupId } : {}),
                    },
                    headers: {
                        Authorization: 'Bearer ' + jwt,
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data.Result;
        },
        {
            enabled: enabled && !!dataSourceId && !!host,
        }
    );
};
